export const DynamicValues = {
	user: {
		NAME: '{{user.name}}',
		EMAIL: '{{user.email}}',
		PHONE: '{{user.phone}}',
		ID: '{{user.loginId}}'
	},
	sentTo: {
		EMAIL: '{{sentTo.maskedEmail}}',
		PHONE: '{{sentTo.maskedPhone}}'
	},
	input: {
		EMAIL: '{{inputs.email}}',
		PHONE: '{{inputs.phone}}',
		EXTERNAL_ID: '{{inputs.loginId}}'
	},
	redirect: {
		URL: '{{.redirectUrl}}',
		KEY_1: '{{.redirectUrlKey1}}',
		KEY_2: '{{.redirectUrlKey2}}',
		KEY_3: '{{.redirectUrlKey3}}'
	},
	auth: {
		TOKEN: '{{.token}}',
		EXP_TIME: '{{.expirationTime}}',
		CODE: '{{.code}}',
		DOMAIN: '{{.domain}}'
	},
	project: {
		NAME: '{{.projectName}}'
	}
};
